<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="授权类型" v-if="!row">
        <el-select v-model="form.type">
          <el-option v-for="item in licenseType" :key="item.id" :value="item.id" :label="item.msg"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="row" label="状态" prop="status">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-select v-model="form.unit">
          <el-option v-for="item in licensePriceUnit" :key="item.id" :value="item.id" :label="item.msg"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="价格(元)" prop="price">
        <el-input-number v-model.trim="form.price" :min="0.01" :max="999999" :precision="2"></el-input-number>
      </el-form-item>
      <el-form-item label="优惠方式">
        <el-radio-group v-model="discountType" @change="discountTypeChange">
          <el-radio :label="0">减免</el-radio>
          <el-radio :label="1">打折</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="discountType === 0">
        <el-form-item label="优惠价(元)" prop="discountAmount">
          <el-input-number v-model.trim="form.discountAmount" :min="0" :max="form.price - 0.01" :key="form.price" :precision="2"></el-input-number>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="折扣率" prop="discountRate">
          <el-input-number v-model.trim="form.discountRate" :min="0.1" :max="10" :precision="1" @change="discountRateChange"></el-input-number>
        </el-form-item>
      </template>
      <el-form-item label="优惠后">
        <span class="color-primary" style="line-height: 32px">{{discountAfterPrice}}元</span>
      </el-form-item>
      <el-form-item label="是否推荐" prop="is_recommend">
        <el-switch v-model="form.is_recommend"></el-switch>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model.trim="form.remark" clearable :maxlength="128"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {licenseType, licensePriceUnit} from "@utils/formatList"
export default {
  name: "DomainOperate",
  props: {dialogData: Object},
  data() {
    return {
      licenseType,
      licensePriceUnit,
      discountType: 0,
      form: {
        type: "ai",
        status: true,
        duration: 1,
        unit: "day",
        price: 1,
        discountAmount: 0,
        discountRate: 10,
        is_recommend: true,
        remark: "",
      },
      rules: {},
      row: this.dialogData.row,
    }
  },
  computed: {
    discountAfterPrice() {
      const { price, discountAmount } = this.form;
      if (this.discountType === 0) {
        return (price - discountAmount).toFixed(2);
      }
      return (price * this.form.discountRate / 10).toFixed(2);
    }
  },
  created() {
    let row = this.dialogData.row;
    if (row) {
      this.form.type = row.type;
      this.form.status = row.status;
      this.form.duration = row.duration;
      this.form.unit = row.unit;
      this.form.price = +this.convertYuan(row.price);
      this.form.is_recommend = row.is_recommend;
      this.form.remark = row.remark || "";
      // 转换 discount_type 和 discount_value 到表单格式
      if (row.discount_type === 0) {
        this.discountType = 0;
        this.form.discountAmount = 0;
        this.form.discountRate = 10;
      } else if (row.discount_type === 1) {
        this.discountType = 0;
        this.form.discountAmount = +this.convertYuan(row.discount_value);
        this.form.discountRate = 10;
      } else if (row.discount_type === 2) {
        this.discountType = 1;
        this.form.discountAmount = 0;
        this.form.discountRate = row.discount_value / 10;
      }
    }
  },
  methods: {
    discountTypeChange() {
      this.form.discountRate = 10;
      this.form.discountAmount = 0;
    },
    discountRateChange() {
      // discountRate 变化时无需额外处理，优惠后价格由 computed 自动计算
    },
    confirm() {
      let row = this.dialogData.row;
      row ? this.revise(row) : this.add();
    },
    dealData(nv) {
      if ("price" in nv) {
        nv.price = this.convertFen(nv.price);
      }
      // 根据 UI discountType 映射到 API 的 discount_type 和 discount_value
      if (this.discountType === 0 && this.form.discountAmount > 0) {
        nv.discount_type = 1;
        nv.discount_value = this.convertFen(this.form.discountAmount);
      } else if (this.discountType === 1) {
        nv.discount_type = 2;
        nv.discount_value = Math.round(this.form.discountRate * 10);
      } else {
        nv.discount_type = 0;
        nv.discount_value = 0;
      }
      delete nv.discountAmount;
      delete nv.discountRate;
    },
    add() {
      this.$refs["form"].validate(async isOk => {
        if (isOk) {
          const nv = {
            ...this.form,
          };
          this.dealData(nv);
          let res = await this.$Http.addLicensePrice(nv);
          if (res) {
            this.msgSuccess("操作成功");
            this.$emit("getData");
            this.dialogData.visible = false;
          }
        }
      });
    },
    revise(row) {
      this.$refs["form"].validate(async isOk => {
        if (isOk) {
          this.openConfirm("修改该授权价格", async () => {
            const nv = {
              license_price_id: row.id,
              ...this.form
            };
            this.dealData(nv);
            let res = await this.$Http.modLicensePrice(nv);
            if (res) {
              this.msgSuccess("操作成功");
              this.$emit("getData");
              this.dialogData.visible = false;
            }
          });
        }
      });
    },
  }
}
</script>

<style scoped>

</style>